export const faqs = [
  {
    q: "瓜田吃瓜是一个什么样的平台？",
    a: "瓜田吃瓜是一个以泛娱乐话题为核心的内容聚合与讨论社区，把综艺、影视、音乐、演出、明星动态等热点集中在一起，并保留不同立场的观点讨论。你可以在这里快速了解一个话题的来龙去脉，也能看到大家为什么会吵起来。",
  },
  {
    q: "话题榜的排序依据是什么？",
    a: "话题榜综合了站内阅读量、讨论区回复数量、观点分歧程度和近期热度变化四个维度，并且每小时更新一次。单纯阅读量高但讨论很少的话题，不会排得特别靠前，因为我们更看重是否真的有人在交流。",
  },
  {
    q: "讨论区的观点会经过筛选吗？",
    a: "我们会筛选违反社区规范的内容，例如人身攻击、未经证实的指控和明显的广告。但立场本身不会被筛选，支持、质疑和中立的观点都会被保留，观点交锋正是讨论区存在的意义。",
  },
  {
    q: "为什么有些话题的结论看起来并不明确？",
    a: "娱乐类话题往往没有唯一答案。我们倾向于呈现事件的时间线、各方的说法和讨论中的主要分歧点，而不是替读者下结论。把信息整理清楚，判断留给你。",
  },
  {
    q: "内容更新的频率是怎样的？",
    a: "工作日的热榜每个小时更新一次，深度话题和行业观察栏目每周更新三到五篇。遇到突发性话题时，会在事件有明确进展后尽快补充时间线。",
  },
  {
    q: "我可以投稿或参与内容创作吗？",
    a: "可以。长期活跃在讨论区、观点表达清晰且遵守社区规范的用户，我们会不定期邀请参与话题整理和栏目撰稿。你也可以直接通过页面底部的邮箱联系我们。",
  },
  {
    q: "发现内容有误怎么办？",
    a: "欢迎指出。你可以通过联系方式发送具体话题和错误说明，并附上可查证的信息来源。核实之后我们会更新内容，并在话题页标注修订时间。",
  },
  {
    q: "在讨论区发言需要注意什么？",
    a: "对观点不对人。你可以强烈质疑一个说法，但请不要攻击发表这个说法的人。另外，涉及具体个人时，请以已公开的信息为依据，避免传播未经核实的说法。",
  },
];